import { render, staticRenderFns } from "./footerBlock.vue?vue&type=template&id=e1a48438&scoped=true&"
import script from "./footerBlock.vue?vue&type=script&lang=js&"
export * from "./footerBlock.vue?vue&type=script&lang=js&"
import style0 from "./footerBlock.vue?vue&type=style&index=0&id=e1a48438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a48438",
  null
  
)

export default component.exports